import { apiClient } from './api'

/** Web-push subscription helper for attendees. */

function urlBase64ToUint8Array(base64: string): Uint8Array {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4)
  const b64 = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/')
  const raw = atob(b64)
  const out = new Uint8Array(raw.length)
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i)
  return out
}

export const pushService = {
  getConfig: () =>
    apiClient
      .get<{ enabled: boolean; publicKey: string }>('/push/config')
      .then((r) => r.data)
      .catch(() => ({ enabled: false, publicKey: '' })),

  /** Subscribe this browser to push for an event. Returns true on success. */
  async subscribe(eventId: string): Promise<boolean> {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false
    const cfg = await this.getConfig()
    if (!cfg.enabled || !cfg.publicKey) return false

    const permission = await Notification.requestPermission()
    if (permission !== 'granted') return false

    const reg = await navigator.serviceWorker.ready
    const existing = await reg.pushManager.getSubscription()
    const sub =
      existing ??
      (await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(cfg.publicKey) as BufferSource,
      }))

    const json = sub.toJSON() as { endpoint?: string; keys?: Record<string, string> }
    await apiClient.post(`/events/${eventId}/push/subscribe`, {
      endpoint: json.endpoint,
      keys: json.keys,
    })
    return true
  },

  async isSubscribed(): Promise<boolean> {
    if (!('serviceWorker' in navigator)) return false
    try {
      const reg = await navigator.serviceWorker.ready
      return Boolean(await reg.pushManager.getSubscription())
    } catch {
      return false
    }
  },
}
